import { I18nProvider, useI18n } from "@/i18n";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { TrustStrip } from "@/components/site/TrustStrip";
import { BrandStrip } from "@/components/site/BrandStrip";
import { Services } from "@/components/site/Services";
import { RoofComparison } from "@/components/site/RoofComparison";
import { WhyRevolin } from "@/components/site/WhyRevolin";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { Process } from "@/components/site/Process";
import { WeatherSection } from "@/components/site/WeatherSection";
import { ServiceAreas } from "@/components/site/ServiceAreas";
import { Faq } from "@/components/site/Faq";
import { ContactCta } from "@/components/site/ContactCta";
import { Footer } from "@/components/site/Footer";
import { StickyCta } from "@/components/site/StickyCta";
import { accessibilityCopy } from "@/i18n/accessibility";

export function HomePage() {
  const { t, locale } = useI18n();

  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[60] focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-sm focus:text-primary-foreground"
      >
        {accessibilityCopy[locale].skip}
      </a>
      <Header />
      <main id="main" tabIndex={-1}>
        <Hero />
        <TrustStrip />
        <Services />
        <RoofComparison />
        <WhyRevolin />
        <BeforeAfter />
        <Process />
        <WeatherSection />
        <ServiceAreas />
        <BrandStrip />
        <Faq />
        <ContactCta />
      </main>
      <Footer />
      <StickyCta />
      <span className="sr-only">{t.meta.description}</span>
    </>
  );
}

export function HomeRoute({ locale }: { locale?: "en-ca" }) {
  return (
    <I18nProvider initialLocale={locale ?? "en-ca"}>
      <HomePage />
    </I18nProvider>
  );
}
